import { type MantineColor } from '@mantine/core';
import { TraderStatus } from './model';

type TraderStatusMeta = Record<
    TraderStatus,
    {
        color: MantineColor;
        label: string;
    }
>;

export const traderStatusMeta = {
    [TraderStatus.STATUS_UNSPECIFIED]: {
        color: 'gray.5',
        label: 'Не определён',
    },
    [TraderStatus.STATUS_CREATED]: {
        color: 'blue.5',
        label: 'Создан',
    },
    [TraderStatus.STATUS_ACTIVE]: {
        color: 'green.6',
        label: 'Активен',
    },
    [TraderStatus.STATUS_BLOCKED]: {
        color: 'red.6',
        label: 'Заблокирован',
    },
} as const satisfies TraderStatusMeta;

export const traderStatusColors: Record<TraderStatus, MantineColor> = {
    [TraderStatus.STATUS_UNSPECIFIED]: traderStatusMeta[TraderStatus.STATUS_UNSPECIFIED].color,
    [TraderStatus.STATUS_CREATED]: traderStatusMeta[TraderStatus.STATUS_CREATED].color,
    [TraderStatus.STATUS_ACTIVE]: traderStatusMeta[TraderStatus.STATUS_ACTIVE].color,
    [TraderStatus.STATUS_BLOCKED]: traderStatusMeta[TraderStatus.STATUS_BLOCKED].color,
} as const;

export const traderStatuses = [
    {
        value: TraderStatus.STATUS_CREATED,
        label: traderStatusMeta[TraderStatus.STATUS_CREATED].label,
    },
    {
        value: TraderStatus.STATUS_ACTIVE,
        label: traderStatusMeta[TraderStatus.STATUS_ACTIVE].label,
    },
    {
        value: TraderStatus.STATUS_BLOCKED,
        label: traderStatusMeta[TraderStatus.STATUS_BLOCKED].label,
    },
] as const;
